import * as React from 'react';

const Phone = () => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="shared-trip"
        transform="translate(-105.000000, -545.000000)"
        fill="#FFFFFF"
        fillRule="nonzero">
        <g id="Avatars" transform="translate(32.000000, 336.000000)">
          <g id="search-copy-6" transform="translate(0.000000, 194.000000)">
            <path
              d="M97.999215,33.7172959 C98.0308787,32.443716 97.1011729,31.3486205 95.8371886,31.1706564 C94.6303926,31.0118076 93.4454759,30.7172173 92.3050407,30.2925049 C91.3863365,29.9478493 90.3506615,30.1682903 89.6527873,30.8570309 L88.0564073,32.4502487 C84.9094699,30.6643952 82.3038526,28.0639393 80.5144545,24.9232356 L82.1108345,23.3300178 C82.8009422,22.6335261 83.0218207,21.5999025 82.676481,20.6830182 C82.2509256,19.5448421 81.9557506,18.3622725 81.7965865,17.1578671 C81.6199802,15.9108511 80.5444515,14.9877287 79.2826023,15.0001233 L75.5116259,15.0001233 C74.8059433,15.0007866 74.1330318,15.2974274 73.6572681,15.8175834 C73.1815044,16.3377393 72.9466998,17.0335112 73.0102115,17.7349381 C73.4228104,21.6125975 74.7448331,25.3387317 76.8691774,28.611472 C78.7990828,31.6425649 81.3740211,34.2124025 84.4111301,36.1384851 C87.6755376,38.2512481 91.3909986,39.5703524 95.2589722,39.9898068 C95.9639737,40.0533951 96.6631679,39.8174023 97.184782,39.3398051 C97.7063962,38.862208 98.0020883,38.1872692 97.999215,37.4808024 L97.999215,33.7172959 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Phone;



// WEBPACK FOOTER //
// ./src/assets/images/icons/phone.js